// DEPENDENCIES
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useFormik } from "formik";
import _ from 'lodash';
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
// COMPONENTS
import { Link } from "react-router-dom";
import { Button, Modal, Form } from "react-bootstrap";
import InputMask from "react-input-mask";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { FilePond, registerPlugin } from "react-filepond";
import SVG from "react-inlinesvg";
// CUSTOM COMPONENTS
import * as alert from "../../../redux/alertSnackBarRedux";
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import Constants from "../../../constants/constants";
import { getInputClasses, convertJsonToFormData } from "../../../helpers/helper";
import ClientRegisterValidator from '../../../helpers/validators/ClientRegisterValidator';
import * as clientService from "../../../services/management/clientService";
import * as clientProfileOverView from "../../../redux/ClientProfileOverViewRedux";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const GeneralInformation = (props) => {
    const { showAlert, location, clientProfile, updateClientProfile, history } = props;
    let clientId = props.match.params.id;
    const [initialValues, setInitialValues] = useState(
        {
            accountNumber: '',
            name: '',
            primaryPhone: '',
            email: '',
            additionalEmails: '',
            contactName: '',
            phoneNumber: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipCode: '',
            isActive: false,
        }
    )
    const [loading, setloading] = useState(false);
    const [clientRegisterError, setClientRegisterError] = useState("");
    const [uploadedFile, setUploadedFile] = useState([]);
    const [pic, setPic] = useState(`url(${Constants.API_URL + "Attachments/UserImages/blank.png"})`);
    const [showModal, setShowModal] = useState(false);
    const [logo, setLogo] = useState([]);

    useEffect(() => {
        clientService.getClientById(clientId).then(res => {
            var model = { ...res };
            model.address1 = res.address.address1;
            model.address2 = res.address.address2 ? res.address.address2 : "";
            model.city = res.address.city;
            model.state = res.address.state;
            model.zipCode = res.address.zipCode;

            setPic(`url(${Constants.API_URL + res.logoPath}`);
            setInitialValues(model);
        })
    }, [])


    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: ClientRegisterValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            registerClientHandler(values, setStatus, setSubmitting);
        }
    });

    const registerClientHandler = (values, setStatus, setSubmitting) => {
        setloading(true);
        var submissionModel = _.pick(values, ["id", "accountNumber", "primaryPhone", "email", "name", "isActive", "contactName", "additionalEmails"]);
        submissionModel.address = _.pick(values, ["address1", "address2", "city", "state", "zipCode"]);

        clientService.updateClient(submissionModel).then(res => {
            showAlert({ message: res.message, variant: "success" });
            updateClientProfile({
                ...clientProfile,
                name: submissionModel.name,
                email: submissionModel.email,
                primaryPhone: submissionModel.primaryPhone,
                location: submissionModel.address.city + ", " + submissionModel.address.state,
            });

        }).catch(err => {
            showAlert({ message: err.message, variant: "error" });
        }).finally(() => {
            setloading(false);
            setSubmitting(false);
        });
        // setloading(true);
        // values.address = {
        //     address1: values.address1,
        //     address2: values.address2,
        //     city: values.city,
        //     state: values.state,
        //     zipCode: values.zipCode
        // }
        // if (uploadedFile.length > 0)
        //     values.uploadedFile = uploadedFile[0].file;

        // registerClient(values, setSubmitting);
    };

    const registerClient = (values, setSubmitting) => {
        clientService.saveClient(convertJsonToFormData(values)).then(res => {
            props.history.push('management/clients');
            showAlert({ message: res.message, variant: 'success' });
        }).catch(ex => setClientRegisterError(ex.message))
            .finally(() => setloading(false), setSubmitting(false))
    }

    const handleModalClose = () => {
        setShowModal(false);
    }

    const updateLogo = () => {
        let pictureModel = {
            id: clientProfile.id,
            uploadedFile: logo[0].file
        }

        clientService.updateClientLogo(convertJsonToFormData(pictureModel)).then(res => {
            updateClientProfile({ ...clientProfile, imageUrl: res.imageUrl });
            setPic(`url(${Constants.API_URL + res.imageUrl}`);
            showAlert({ message: res.message, variant: "success" });
            handleModalClose();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: "error" })
        });
    }

    return (
        <>
            <Modal show={showModal} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Logo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FilePond
                        files={logo}
                        onupdatefiles={setLogo}
                        labelIdle='Drag & Drop image or <span class="filepond--label-action">Browse</span>'
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                        Close
                    </Button>
                    <Button disabled={logo.length === 0} variant="primary" onClick={updateLogo}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
            <form
                className="card card-custom card-stretch"
                onSubmit={formik.handleSubmit}
            >
                {loading && <ModalProgressBar />}
                <div className="card-header py-3">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">
                            Edit Client
                    </h3>
                        <span className="text-muted font-weight-bold fz-xs mt-1">
                            Please fill out the form below. Fields marked as <code>*</code> are required.
                    </span>
                    </div>
                    <div className="card-toolbar">
                        <button
                            type="submit"
                            className="btn btn-success mr-2"
                            disabled={
                                formik.isSubmitting || (formik.touched && !formik.isValid)
                            }
                        >
                            Save Changes
                        {formik.isSubmitting}
                        </button>
                        <a
                            onClick={() => history.goBack()}
                            className="btn btn-danger"
                        >
                            Cancel
                    </a>
                    </div>
                </div>
                <div className="form">
                    <div className="card-body">
                        {
                            clientRegisterError ?
                                <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                                    <div className="alert-text font-weight-bold">
                                        {clientRegisterError}
                                    </div>
                                </div>
                                : <></>
                        }
                        <div className="row">
                            <label className="col-xl-3"></label>
                            <div className="col-lg-9 col-xl-6">
                                <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Client Info</h5>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">Company Logo</label>
                            <div className="col-lg-9 col-xl-6">
                                <div
                                    className="image-input image-input-outline"
                                    id="kt_profile_avatar"
                                >
                                    <div
                                        className="image-input-wrapper background-image-container"
                                        style={{ backgroundImage: pic }}
                                    />
                                    <label
                                        className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                        data-action="change"
                                        data-toggle="tooltip"
                                        title=""
                                        data-original-title="Change avatar"
                                        onClick={() => setShowModal(true)}
                                    >
                                        <i className="fa fa-pen icon-sm text-muted"></i>
                                    </label>
                                    <span
                                        className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                        data-action="cancel"
                                        data-toggle="tooltip"
                                        title=""
                                        data-original-title="Cancel avatar"
                                    >
                                        <i className="ki ki-bold-close icon-xs text-muted"></i>
                                    </span>
                                </div>
                                <span className="form-text text-muted">
                                    Allowed file types: png, jpg, jpeg.
                                </span>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Business Name*
                        </label>
                            <div className="col-lg-9 col-xl-6">
                                <input
                                    type="text"
                                    placeholder="XYZ Company"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "name")}`}
                                    name="name"
                                    {...formik.getFieldProps("name")}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.name}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        {/* <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Account Number
                            </label>
                            <div className="col-lg-9 col-xl-6">
                                <input
                                    type="text"
                                    placeholder="0012345"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "accountNumber")}`}
                                    name="accountNumber"
                                    {...formik.getFieldProps("accountNumber")}
                                />
                                {formik.touched.accountNumber && formik.errors.accountNumber ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.accountNumber}
                                    </div>
                                ) : null}
                            </div>
                        </div> */}
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Contact Name
                            </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} /> </span>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="John Doe"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "contactName")}`}
                                        name="contactName"
                                        {...formik.getFieldProps("contactName")}
                                    />
                                </div>
                                {formik.touched.contactName && formik.errors.contactName ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.contactName}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Email Address
                            </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail-at.svg")} /> </span>
                                        </span>
                                    </div>
                                    <input
                                        type="email"
                                        placeholder="john.doe@aes.net"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "email")}`}
                                        name="email"
                                        {...formik.getFieldProps("email")}
                                    />
                                </div>
                                {formik.touched.email && formik.errors.email ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.email}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Additional Email Addresses
                        </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="input-group input-group-lg input-group-solid">
                                    <Form.Control
                                        as="textarea"
                                        rows="2"
                                        type="additionalEmails"
                                        placeholder="Enter Additional Emails"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="additionalEmails"
                                        {...formik.getFieldProps("additionalEmails")}
                                    />
                                </div>
                                <span class="form-text text-muted">Email addresses must be separated with commas</span>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Contact Phone
                        </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Adress-book1.svg")} /> </span>                                        </span>
                                    </div>
                                    <InputMask
                                        mask="(999) 999-9999"
                                        type="text"
                                        placeholder="(225)-000-0000"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "primaryPhone")}`}
                                        name="primaryPhone"
                                        {...formik.getFieldProps("primaryPhone")}
                                    />
                                </div>
                                {formik.touched.primaryPhone && formik.errors.primaryPhone ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.primaryPhone}
                                    </div>
                                ) : null}
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Is Active?
                        </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="checkbox-list">
                                    <label className="checkbox checkbox-primary">
                                        <input
                                            checked={formik.values.isActive}
                                            type="checkbox"
                                            name="admin"
                                            {...formik.getFieldProps("isActive")}
                                        />
                                        <span></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <label className="col-xl-3"></label>
                            <div className="col-lg-9 col-xl-6">
                                <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Address Info</h5>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Address 1*
                        </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-home"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="123 Second St."
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address1")}`}
                                        name="address1"
                                        {...formik.getFieldProps("address1")}
                                    />
                                </div>
                                {formik.touched.address1 && formik.errors.address1 ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.address1}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Address 2
                        </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-building"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Apt# 1"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address2")}`}
                                        name="address2"
                                        {...formik.getFieldProps("address2")}
                                    />
                                </div>
                                {formik.touched.address2 && formik.errors.address2 ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.address2}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                City*
                        </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-city"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Baton Rouge"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "city")}`}
                                        name="city"
                                        {...formik.getFieldProps("city")}
                                    />
                                </div>
                                {formik.touched.city && formik.errors.city ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.city}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                State*
                        </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-flag-usa"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Louisiana"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "state")}`}
                                        name="state"
                                        {...formik.getFieldProps("state")}
                                    />
                                </div>
                                {formik.touched.state && formik.errors.state ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.state}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Zip Code*
                        </label>
                            <div className="col-lg-9 col-xl-6">
                                <div className="input-group input-group-lg input-group-solid">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fa fa-location-arrow"></i>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="70809"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "zipCode")}`}
                                        name="zipCode"
                                        {...formik.getFieldProps("zipCode")}
                                    />
                                </div>
                                {formik.touched.zipCode && formik.errors.zipCode ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.zipCode}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

const mapStateToProps = (state) => ({
    clientProfile: state.clientProfile
})

export default connect(mapStateToProps, { ...clientProfileOverView.actions, ...alert.actions })(GeneralInformation);